module.exports = __webpack_public_path__ + "img/ok.ea7c05a9.svg";